import { useToast } from '@givebutter/primitives/toast';
import * as DropdownMenu from 'components/dropdown-menu';
import * as Tooltip from 'components/tooltip';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { usePinCampaign } from 'customHooks/usePinCampaign';
import { Campaign } from 'types/domain';

interface PinCampaignDropdownItemProps {
    campaign: Campaign;
}
const PinCampaignDropdownItem = ({ campaign }: PinCampaignDropdownItemProps) => {
    const isPinned = campaign.is_pinned;
    const { canPinCampaigns } = useCurrentAccount();
    const { success } = useToast();

    const { mutate, isPending } = usePinCampaign({
        onSuccess: () => {
            success(`Campaign successfully ${isPinned ? 'unpinned from' : 'pinned to'} sidebar.`);
        },
    });

    if (campaign.type === 'external') {
        return null;
    }

    return (
        <Tooltip.Root open={canPinCampaigns ? false : undefined}>
            <Tooltip.Trigger className="w-full text-left">
                <DropdownMenu.Item
                    disabled={!isPinned && !canPinCampaigns}
                    onClick={() => {
                        if (!isPending) {
                            mutate(campaign);
                        }
                    }}
                >
                    {isPinned ? 'Unpin from sidebar' : 'Pin to sidebar'}
                </DropdownMenu.Item>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content inverse>
                    <Tooltip.Arrow inverse />
                    <p>Cannot pin more than 5 campaigns</p>
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    );
};

export { PinCampaignDropdownItem };
